// extracted by mini-css-extract-plugin
module.exports = {"list":"Ratings_list__1ROIe","item":"Ratings_item__2kKEk"};